import React from 'react';
import styled from 'styled-components';

const Wrapper  = styled.div.withConfig({displayName:'-Wrapper '})`
  position: relative;
  width: 100%;
  height: ${props => props.height};
`;

const Spacer = ({height="35px"}) => {
  return (
    <Wrapper height={height} />
  )
}

export default Spacer;
